import { createApp } from 'vue'
import App from './App.vue'

//npm install firebase
import firebase from "firebase/app";
import "firebase/firestore";


//서버1
const firebaseConfig = {
  apiKey: "AIzaSyAdiOLCsh_fLpfqdxc9XcoD6Ldd_Q_TJKs",
  authDomain: "colorpopgame.firebaseapp.com",
  projectId: "colorpopgame",
  storageBucket: "colorpopgame.appspot.com",
  messagingSenderId: "805503325462",
  appId: "1:805503325462:web:70197b13d472808984ac37"
};

//서버2

// const firebaseConfig = {
//   apiKey: "AIzaSyC94eUwKvXE2UTnnUsd8T5F9KhRRsNRyY4",
//   authDomain: "colorpopgame2.firebaseapp.com",
//   projectId: "colorpopgame2",
//   storageBucket: "colorpopgame2.appspot.com",
//   messagingSenderId: "423299685901",
//   appId: "1:423299685901:web:f34e483e3cde859ada7f44"
// };

firebase.initializeApp(firebaseConfig);
export const db = firebase.firestore();

createApp(App).mount('#app')
